import { init } from '../utils/init';
import initProductVariants from '../components/product-variants/product-variants';

init((): void => {
  initProductVariants();
});
